"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lang_1 = require("../lang");
const filter_1 = __importDefault(require("./filter"));
function pick(obj, props) {
    if (!(0, lang_1.isObject)(obj) || !Array.isArray(props)) {
        return {};
    }
    const propsSet = new Set(props);
    return (0, filter_1.default)(obj, (value, key) => propsSet.has(key));
}
exports.default = pick;
